var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 69,
    viewBox: "0 0 58 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8758 65.3691C30.3046 65.7793 29.6191 66 28.9159 66C28.2126 66 27.5271 65.7793 26.9559 65.3691C10.0546 53.3223 -7.88263 28.5426 10.2506 10.6369C15.2287 5.73993 21.9329 2.99693 28.9159 3C35.9158 3 42.6322 5.74746 47.5811 10.6334C65.7143 28.5391 47.7771 53.3153 30.8758 65.3691Z",
    stroke: "#B0B0B0",
    strokeWidth: 4.29545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9164 34.5003C30.7729 34.5003 32.5533 33.7628 33.8661 32.4501C35.1788 31.1373 35.9163 29.3569 35.9163 27.5004C35.9163 25.6439 35.1788 23.8634 33.8661 22.5507C32.5533 21.238 30.7729 20.5005 28.9164 20.5005C27.0599 20.5005 25.2795 21.238 23.9667 22.5507C22.654 23.8634 21.9165 25.6439 21.9165 27.5004C21.9165 29.3569 22.654 31.1373 23.9667 32.4501C25.2795 33.7628 27.0599 34.5003 28.9164 34.5003Z",
    stroke: "#B0B0B0",
    strokeWidth: 4.29545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationGray);
export default __webpack_public_path__ + "static/media/location_gray.81bc148bc1adeb2b7bc4758861fd8243.svg";
export { ForwardRef as ReactComponent };